import { TenantUserTicket } from "../../entities/TenantUserTicket";

export function getTicketsToDisplay(
  tickets: TenantUserTicket[] | undefined,
  statusesToDisplayOnThePage?: string[],
): TenantUserTicket[] {
  const statusFilter =
    statusesToDisplayOnThePage !== undefined &&
    statusesToDisplayOnThePage !== null &&
    statusesToDisplayOnThePage.length > 0
      ? statusesToDisplayOnThePage
      : undefined;

  return (
    tickets?.filter((ticket) => (statusFilter ? statusFilter.includes(ticket.status) : true)) ?? []
  );
}
